module.exports = __webpack_public_path__ + "img/kenesto.bcebb126.png";